<template>
  <div class="btn__back-to-top" @click="onBackToTopClick" :style="{ marginBottom: browser.isIE || browser.isEdge ? '40px' : '0px' }">
    <i class="icon icon--back-to-top"></i>
    <p v-if="!hideLabel">{{ $t('common.backToTop') }}</p>
  </div>
</template>

<script>
import browser from '../../libs/browser'

export default {
  name: 'BackToTop',
  props: {
    refName: {
      type: String,
      required: true
    },
    hideLabel: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    onBackToTopClick () {
      if (this.refName) {
        let component = this
        let target

        while (component) {
          target = component.$refs[this.refName]

          if (target) {
            if (target.$el) {
              target = target.$el
            }
            break
          }
          component = component.$parent
        }

        if (target) {
          let duration = 500
          if (target.scrollTop === 0) return

          const cosParameter = target.scrollTop / 2
          let scrollCount = 0
          let oldTimestamp = null

          let step = (newTimestamp) => {
            if (oldTimestamp !== null) {
              // if duration is 0 scrollCount will be Infinity
              scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration
              if (scrollCount >= Math.PI) {
                target.scrollTop = 0
                return
              }
              target.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount)
            }
            oldTimestamp = newTimestamp
            window.requestAnimationFrame(step)
          }
          window.requestAnimationFrame(step)
        }
        this.$emit('onBackToTopClick')
      }
    }
  },
  data () {
    return {
      browser: browser
    }
  }
}
</script>

<style lang="scss" scoped>
.btn__back-to-top {
  cursor: pointer;
  width: 100px;
  margin: 40px auto 0;
  text-align: center;

  .icon {
    position: relative;

    &:hover {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.06);
        border-radius: 50%;
      }
    }
  }

  p {
    margin-top: 8px;
  }
}
</style>
